<span class="status-pill" [attr.data-status]="status" role="status">
  @if (status === 'indexing') {
    <span class="status-pill__dot" aria-hidden="true"></span>
  }
  <span class="status-pill__label">{{ resolvedLabel() }}</span>
</span>
